import type { Term } from "@/api";

export function getCurrentTerm(terms: Term[], today: Date = new Date()): Term | null {
  // The API dates are `YYYY-MM-DD`
  const day = today.toISOString().slice(0, 10);

  return (
    terms.find(
      (term) =>
        term.startsOn !== null &&
        term.endsOn !== null &&
        term.startsOn <= day &&
        day <= term.endsOn,
    ) ?? null
  );
}

/**
 * The season and year a term starting today would carry, for a school too new
 * to have its own calendar.
 */
export function getSeasonTermLabel(today: Date = new Date()): string {
  return `${getSeason(today.getUTCMonth() + 1)} ${today.getUTCFullYear()}`;
}

function getSeason(month: number): string {
  if (month <= 5) return "Spring";
  if (month <= 7) return "Summer";
  return "Fall";
}

export function getLatestTerm(terms: Term[]): Term | null {
  const dated = terms.filter((term): term is Term & { startsOn: string } => term.startsOn !== null);
  if (dated.length === 0) return terms.at(-1) ?? null;

  return dated.reduce((latest, term) => (term.startsOn > latest.startsOn ? term : latest));
}
